import { render, staticRenderFns } from "./AddGroupDialog.vue?vue&type=template&id=c9f58bdc&"
import script from "./AddGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AddGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports